import moment from 'moment';
const getDefaultRanges = (date) => [
    {
        label: 'Hoje',
        startDate: date,
        endDate: date
    },
    {
        label: 'Ontem',
        startDate: moment(date).subtract(1, 'days').toDate(),
        endDate: moment(date).toDate()
    },
    {
        label: 'Esta semana',
        startDate: moment(date).startOf('week').toDate(),
        endDate: moment(date).endOf('week').toDate()
    },
    {
        label: 'Última semana',
        startDate: moment(date).subtract(1, 'week').startOf('week').toDate(),
        endDate: moment(date).subtract(1, 'week').endOf('week').toDate()
    },
    {
        label: 'Ultimos 7 dias',
        startDate: moment(date).subtract(7, 'days').toDate(),
        endDate: date
    },
    {
        label: 'Últimos 15 dias',
        startDate: moment(date).subtract(15, 'days').toDate(),
        endDate: date
    },
    {
        label: 'Últimos 30 dias',
        startDate: moment(date).subtract(30, 'days').toDate(),
        endDate: date
    }
];
export const defaultRanges = getDefaultRanges(new Date());
